import React, { useState } from "react";
import { FaX } from "react-icons/fa6";
import abiodun from "../assets/img/team/Abiodun Olufemi -Managing Director.jpg";
import amara from "../assets/img/team/Amara Nwachukwu - Admin officer.jpg";
import blessing from "../assets/img/team/Blessing AjibuwaDir. of Finance.jpg";
import daniel from "../assets/img/team/Daniel Abiodun -Director.jpg";
import duru from "../assets/img/team/Duru Ujunwa Cynthia -Operation officer.jpg";
import esther from "../assets/img/team/Esther Oduntola -Accountant.jpg";
import helen from "../assets/img/team/Helen- Marketer.jpg";
import ojo from "../assets/img/team/Ojo balogun- Dispatch officer.jpg";
import oluwaseun from "../assets/img/team/Oluwaseun Oludare- Logistics.jpg";
import sunday from "../assets/img/team/Sunday Abiodun - Marketer1.jpg";
import abiodunOlubunmi from "../assets/img/team/AbiodunOlubunmiDirectorofOperations.png";
import abiodunDavid from "../assets/img/team/AbiodunDavidAdmin.jpg";
import odunodunola from "../assets/img/team/OdunOdunola Olawoye - Marketer.png";
import tobabada from "../assets/img/team/Toba Bada Kayode - Marketing Manager.jpg";
import oriade from "../assets/img/team/OriadeOriade Oyedotun - Marketer.png";
import rosebenson from "../assets/img/team/Rose Benson- Business Development Executive.jpg";
import mendos from "../assets/img/team/Mendos Peter Katu- Logistics officer.jpg";
import asonibare from "../assets/img/team/Asonibare Adeola Theresa-Admin Officer.jpg";

interface TeamMember {
  name: string;
  role: string;
  image: string;
}

const ceo: TeamMember = {
  name: "Abiodun M. O .Olufemi",
  role: "M.D",
  image: abiodun,
};

const otherTeamMembers: TeamMember[] = [
  {
    name: "Amara Nwachukwu",
    role: "Admin officer",
    image: amara,
  },
  {
    name: "Blessing Ajibuwa",
    role: "Dir. of Finance",
    image: blessing,
  },
  {
    name: "Daniel Abiodun",
    role: "Director",
    image: daniel,
  },
  {
    name: "Duru Ujunwa Cynthia",
    role: "Operation officer",
    image: duru,
  },
  {
    name: "Esther Oduntola",
    role: "Accountant",
    image: esther,
  },
  {
    name: "Helen Tishion",
    role: " Business Development Manager",
    image: helen,
  },

  {
    name: "Ojo balogun",
    role: "Dispatch officer",
    image: ojo,
  },
  {
    name: "Oluwaseun Oludare",
    role: "Logistics Officer",
    image: oluwaseun,
  },

  {
    name: "Abiodun Olubunmi",
    role: "Director of Operations",
    image: abiodunOlubunmi,
  },
  {
    name: "Abiodun David",
    role: "Director",
    image: abiodunDavid,
  },
  {
    name: "Rose Benson",
    role: "Business Development Manager",
    image: rosebenson,
  },
  {
    name: "Mendos Peter Katu",
    role: "Logistics officer",
    image: mendos,
  },
  {
    name: "Asonibare Adeola Theresa",
    role: "Admin Officer",
    image: asonibare,
  },
];

const markerters: TeamMember[] = [
  {
    name: "Toba Bada Kayode",
    role: "Marketing Manager",
    image: tobabada,
  },
  {
    name: "OdunOdunola Olawoye",
    role: "Marketer",
    image: odunodunola,
  },
  {
    name: "OriadeOriade Oyedotun",
    role: "Marketer",
    image: oriade,
  },
  {
    name: "Sunday Abiodun",
    role: "Marketer",
    image: sunday,
  },
];
const OurTeam: React.FC = () => {
  const [selectedMember, setSelectedMember] = useState<TeamMember | null>(null);

  const handleImageClick = (member: TeamMember) => {
    setSelectedMember(member);
  };

  const closeModal = () => {
    setSelectedMember(null);
  };

  return (
    <section className="py-12 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl font-bold text-primary mb-4">Meet Our Team</h2>
        <p className="text-gray-600 mb-10">
          Talented individuals behind the success of our company
        </p>

        {/* Circular layout for all screens */}
        <div
          className="relative flex justify-center items-center h-[400px] sm:h-[500px] md:h-[600px] lg:h-[700px]"
          style={{ "--radius": "min(40vw, 300px)" } as React.CSSProperties}
        >
          {/* CEO in the center with tooltip */}
          <div className="absolute flex flex-col items-center w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 group">
            <div className="relative">
              <img
                className="w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 rounded-full object-cover border-4 border-primary cursor-pointer"
                src={ceo.image}
                alt={ceo.name}
                onClick={() => handleImageClick(ceo)}
              />
              <span className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-primary text-white text-xs px-2 py-1 rounded">
                Click me
              </span>
            </div>
          </div>

          {/* Other team members in a circle */}
          {otherTeamMembers.map((member, index) => {
            const angle = (index / otherTeamMembers.length) * 360;
            return (
              <div
                key={index}
                className="absolute transform transition-all duration-300 hover:scale-110 hover:shadow-xl flex flex-col items-center w-20 h-20 sm:w-24 sm:h-24 md:w-24 md:h-24"
                style={{
                  transform: `
                    rotate(${angle}deg) 
                    translate(0, calc(-1 * var(--radius))) 
                    rotate(-${angle}deg)
                  `,
                }}
              >
                <img
                  className="w-[4.1rem] h-[4.1rem] sm:w-24 sm:h-24 md:w-24 md:h-24 rounded-full object-cover border-4 border-primary cursor-pointer"
                  src={member.image}
                  alt={member.name}
                  onClick={() => handleImageClick(member)}
                />
              </div>
            );
          })}
        </div>
        {/* Marketers Section */}
        <div className="mt-20">
          <h3 className="text-2xl font-semibold text-primary mb-12">
            Meet Our Marketers
          </h3>
          <div className="grid grid-cols-1 gap-12">
            {markerters.map((marketer, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-lg overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-xl cursor-pointer"
              >
                <img
                  className="w-full h-48 object-cover"
                  src={marketer.image}
                  alt={marketer.name}
                />
                <div className="p-4">
                  <h4 className="text-lg font-semibold text-primary">
                    {marketer.name}
                  </h4>
                  <p className="text-gray-500">{marketer.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Modal for team member details */}
      {selectedMember && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 relative">
            <button
              className="absolute top-2 px-4 py-2 rounded-lg bg-primary text-white right-2 hover:bg-primary-dark"
              onClick={closeModal}
            >
              <FaX />
            </button>
            <img
              className="w-32 h-32 rounded-full object-cover mx-auto mb-4 border-4 border-primary"
              src={selectedMember.image}
              alt={selectedMember.name}
            />
            <h3 className="text-xl font-semibold text-primary text-center">
              {selectedMember.name}
            </h3>
            <p className="text-gray-500 text-center">{selectedMember.role}</p>
          </div>
        </div>
      )}
    </section>
  );
};

export default OurTeam;
